export default "__VITE_ASSET__27abec19__"